export default __webpack_public_path__ + "7b19eca3ba721a47075ecb6b50a9e0da.svg";